export const CUSTOM_FIELD_NAMES = [
  'custom',
  'source_custom',
  'product_custom',
] as const

export type CustomFieldName = (typeof CUSTOM_FIELD_NAMES)[number]

type FormValues = Partial<
  Record<CustomFieldName, Record<string, unknown> | null>
>

export const remapCustomFields = (
  values: FormValues,
  columnIndex: number,
  target?: { fieldName: CustomFieldName; columnName: string },
): Partial<Record<CustomFieldName, Record<string, unknown>>> =>
  CUSTOM_FIELD_NAMES.reduce<
    Partial<Record<CustomFieldName, Record<string, unknown>>>
  >((updates, fieldName) => {
    const currentFields = values[fieldName] ?? {}
    const fields = Object.fromEntries(
      Object.entries(currentFields).filter(
        ([, value]) => value !== columnIndex,
      ),
    )
    const removedExistingField =
      Object.keys(fields).length !== Object.keys(currentFields).length

    if (target?.fieldName === fieldName) {
      fields[target.columnName] = columnIndex
    }

    if (removedExistingField || target?.fieldName === fieldName) {
      updates[fieldName] = fields
    }

    return updates
  }, {})
